<template>
  <div class="Warp">
	<div class="main">
	  <div class="main-div">
	    <!--内容 start-->
	    <div>
	      <van-dropdown-menu>
	        <van-dropdown-item ref="item" :title="store_name">
	          <van-cell
	            @click="outlet('', '全部门店')"
	            title="全部门店"
	            is-link
	          />
	          <div v-for="(item, index) in option1" :key="index">
	            <van-cell
	              @click="outlet(item.id, item.store_name)"
	              :title="item.store_name"
	              is-link
	            />
	          </div>
	        </van-dropdown-item>
	      </van-dropdown-menu>
	      <van-tabs
	        class="van_tabs"
	        color="rgb(0,170,238)"
	        title-active-color="black"
	        @click="onClick(active)"
	        id="vat_tabs"
	        v-model="active"
	      >
	        <van-tab title="日报表">
	          <van-grid :column-num="5" :border="false" id="vat_grid">
	            <van-grid-item text="支付金额" />
	            <van-grid-item  text="支付订单数" />
	            <van-grid-item text="退款金额" />
	            <van-grid-item text="退款订单数" />
				<van-grid-item text="时间" />
	          </van-grid>
	        </van-tab>
	        <van-tab title="周报表">
	          <van-grid :column-num="5" :border="false" id="vat_grid">
	            <van-grid-item text="支付金额" />
	            <van-grid-item  text="支付订单数" />
	            <van-grid-item text="退款金额" />
	            <van-grid-item text="退款订单数" />
	            <van-grid-item text="时间" />
	          </van-grid>
	        </van-tab>
	        <van-tab title="月报表">
	          <van-grid :column-num="5" :border="false" id="vat_grid">
	            <van-grid-item text="支付金额" />
	            <van-grid-item  text="支付订单数" />
	            <van-grid-item text="退款金额" />
	            <van-grid-item text="退款订单数" />
	            <van-grid-item text="时间" />
	          </van-grid>
	        </van-tab>
	      </van-tabs>
	    </div>
	  </div>
	</div>
	<!--内容 end-->
	<div class="content">
	  <van-list
	    v-model="loading"
	    :finished="finished"
	    finished-text="没有更多了"
	    @load="onLoad"
	    :offset="10"
	  >
	    <div v-for="(item, index) in OrderList" :key="index">
	      <van-grid :column-num="5" :border="false">
	        <van-grid-item :text="'￥'+item.money"> </van-grid-item>
	        <van-grid-item :text="item.count"> </van-grid-item>
	        <van-grid-item :text="'￥'+item.redund_money"> </van-grid-item>
	        <van-grid-item :text="item.redund_count"> </van-grid-item>
	        <van-grid-item :text="item.date	"> </van-grid-item>
	      </van-grid>
	    </div>
	  </van-list>
	</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      limit: 10,
	  summary_type:'day',
      OrderList: [],
      loading: false,
      refreshLoading: false,
      finished: false,
	  active: 0,
	  option1: [],
	  store_id: "",
	  store_name: "",
    };
  },
  mounted() {
    // this.getOrderList();
	this.theStores();
  },
  methods: {
	  //点击报表类型
	  onClick(active) {
		// 每次点击都重新加载
		this.loading = true;
		this.finished = false;
		if (active == "0") {
		  this.summary_type = "day";
		  this.page = 0;
		  this.OrderList = [];
		  this.onLoad();
		  console.log(this.summary_type);
		} else if (active == "1") {
		  this.summary_type = "week";
		  this.page = 0;
		  this.OrderList = [];
		  this.onLoad();
		  console.log(this.summary_type);
		} else if (active == "2") {
		  this.summary_type = "month";
		  this.page = 0;
		  this.OrderList = [];
		  this.onLoad();
		  console.log(this.summary_type);
		}
	  },
	  //全部门店列表
	  theStores() {
	    this.$http
	      .get("/wechat/user/get_merchant_list", {
	        params: {
	          merchant_id: window.sessionStorage.getItem("commercialId"),
	        },
	      })
	      .then((response) => {
	        // console.log(response.data.data);
	        this.option1 = response.data.data;
	        this.number();
	        this.page = 0;
	        this.OrderList = [];
	        this.onLoad();
	      });
	  },
	  //默认选择全部门店
	  number() {
	    if (this.store_id == "") {
	      this.store_id = "";
	      this.store_name = "全部门店";
	    }
	  },
	  //门店选择
	  outlet(a, b) {
	    this.store_id = a;
	    this.store_name = b;
	    console.log(a, b);
	    this.$refs.item.toggle();
	    //    this.choose()
	    this.page = 0;
	    this.OrderList = [];
	    this.onLoad();
	  },
	// 触发下拉刷新更多
	onLoad() {
	  // console.log(this.loading);
	  this.page += 1;
	  this.getOrderList();
	},
	  
    getOrderList() {
      var reqData = {
		summary_type:this.summary_type,
        pageNum: this.page,
        pageSize: this.limit,
		store_id: this.store_id
      };
      this.$http
        .post("/wechat/api.order/consumerOrderStatistics",reqData)
        .then((res1) => {
          var res = res1.body;
          res.rows.map((v) => {
            // let data_time = v.limit_end_date.split(" ");
            // v.date = data_time[0];
            // v.time = data_time[1];
            this.OrderList.push(v);
            // console.log(data_time);
            this.loading = false;
            this.refreshLoading = false;
            if (this.OrderList.length >= res.total) {
              this.finished = true;
            }
          });
        });
    },
    onRefresh() {
      this.page = 1;
      this.OrderList = [];
      this.finished = false;
      this.getOrderList();
    },
    uploader() {
      this.page++;
      this.getOrderList();
    },
  },
};
</script>
<style lang="less" scoped>
.van_grid_item {
  color: #646566;
  font-size: 0.32rem;
  line-height: 1.5;
  word-break: break-all;
}
</style>